import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-teal-700/30 bg-zinc-950 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-157" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-158" data-mp="2vp6cicbkuk8r">
        <div className="text-center" data-id="element-159" data-mp="39hct1zin6t8q">
          <SectionHeading id="problem-title" data-id="element-160" data-mp="39gb4qtcm8a92">Does This Sound <span className="text-orange-400" data-id="element-161" data-mp="35gkin2y1aiav">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-zinc-300" data-id="element-162" data-mp="35in73ijjg3dh">
            You run, maintain or engineer boilers, steam systems and heat exchangers, but the boiler room still holds
            questions you can&apos;t fully answer. When someone talks about steam properties, combustion, water treatment,
            traps, condensate or exchanger performance, you can&apos;t connect all the pieces with confidence.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-teal-700/70 bg-zinc-900 p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-163" data-mp="jeetougupvlp">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-white" data-id="element-164" data-mp="123v2e52owud7">
            <AlertTriangleIcon className="h-5 w-5 text-orange-400" aria-hidden="true" data-id="element-165" data-mp="1726d0i0t78wh" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-166" data-mp="1c33vkvpqe4yi">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-zinc-300" data-id="element-167" data-mp="1g3w41mqs45tq">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-orange-500 shadow-[0_0_10px_rgba(249,115,22,0.6)]" aria-hidden="true" data-id="element-168" data-mp="3dtnnw3626t4i" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-169" data-mp="p1bpttcmn0rt">
          <p className="mx-auto max-w-2xl text-lg font-bold text-white" data-id="element-170" data-mp="p23ml7hyn4jo">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-orange-400 sm:text-3xl" data-id="element-171" data-mp="y205esho596t">You need one organized system.</p>
        </div>
      </div>
    </section>;
}